export default __webpack_public_path__ + "static/media/TwitterRed.ad0d5c4b.webp";